import { gql } from "@apollo/client";

export const MUTATION_ADD_BOOKMARK = gql`
  mutation addBookmark($data: BookmarkInput!) {
    createBookmark(data: $data) {
      data {
        attributes {
          createdAt
        }
      }
    }
  }
`;

export const MUTATION_DELETE_BOOKMARK = gql`
  mutation deleteBookmark($id: ID!) {
    deleteBookmark(documentId: $id) {
      __typename
    }
  }
`;
